export default __webpack_public_path__ + "static/MineralSwimV2_BENEFITS_100_DeadSea_1920x1000-1c57bd7a7016dc327756a4efbcb89f61.jpg";